<script lang="ts">
	import { appName } from "../../../../core/schema/names/appName.js";
	import logo from "../../../../core/assets/logo.svg";
	import type { Image } from "../../../../core/schema/Image.js";
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	export let product: ProductForCustomer;
	export let images: Image[];
	export let containerClass = "";
	export { containerClass as class };

	const { TENANT_LOCALE } = getGlobalSettings();

	$: [primaryImage, ...otherImages] = images;

	$: displayedImage = primaryImage;

	function displayImage(image: Image): void {
		displayedImage = image;
	}

	function displayPrimaryImage(): void {
		displayedImage = primaryImage;
	}

	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="relative {containerClass}">
	{#if displayedImage}
		<DynamicPicture
			class="md:max-h-[37rem] md:max-w-[37rem]"
			imgClass="w-full h-full rounded-lg aspect-square object-cover"
			image={displayedImage}
			lightboxId={product.name[TENANT_LOCALE]}
			lightboxWidth={800}
			width={600}
			height={600}
			bucket="storage"
			loading="eager"
			alt="Fotografie – {product.name[TENANT_LOCALE]} (1/{images.length})"
			preload
		/>
	{:else}
		<div
			class="bg-secondary-40 flex aspect-square h-auto max-h-[37rem] w-full max-w-[37rem] items-center justify-center rounded-md"
		>
			<StaticPicture
				alt="Logo {appName}"
				image={logo}
				class="w-28 opacity-50 lg:w-36 xl:w-40"
				loading="eager"
				width={160}
				height={160}
				preload
			/>
		</div>
	{/if}
	<div class="mt-4 grid grid-cols-4 gap-4">
		{#each otherImages as image, i}
			{#if i < 4}
				<DynamicPicture
					class="max-h-[8.625rem] max-w-[8.625rem]"
					imgClass="w-full h-full rounded-lg object-cover"
					{image}
					lightboxId={product.name[TENANT_LOCALE]}
					lightboxWidth={800}
					width={600}
					height={600}
					bucket="storage"
					loading="eager"
					alt="Fotografie – {product.name[TENANT_LOCALE]} ({i + 2}/{images.length})"
					on:mouseover={() => {
						displayImage(image);
					}}
					on:mouseout={displayPrimaryImage}
					preload
				/>
			{/if}
		{/each}
	</div>
	{#if images.length > 0}
		<p class="text-secondary-300 text-2xs mt-6 w-full font-normal leading-4">
			Fotografie mají pouze ilustrační charakter.
		</p>
	{/if}
</div>
